import DataGrid, {
    Column,
    Pager,
    Paging,
    Scrolling,
    SearchPanel
} from 'devextreme-react/cjs/data-grid'
import useHasPermission from 'hooks/useHasPermission'
import React, { useState } from 'react'
import { Card } from 'react-bootstrap'
import { data } from '../itemMaster'
import { useNavigate } from 'react-router-dom'
import { encodeValue } from 'helpers/hashId'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons'

const InwardFromVendor = () => {
    const HasPermission = useHasPermission()
    const navigate = useNavigate()
    const [refreshKey, setRefreshKey] = useState(0)

    return (
        <div className="page-content">
            <div className="container-fluid">
                <Card>
                    <Card.Header className="d-flex justify-content-between align-items-center">
                        <h5 className="m-0">Inward from Vendor</h5>
                    </Card.Header>

                    <Card.Body>
                        {HasPermission('Customer.Read') && (
                            <DataGrid
                                dataSource={data}
                                remoteOperations={{ groupPaging: true }}
                                showRowLines={true}
                                keyExpr="id"
                                columnAutoWidth={true}
                                // wordWrapEnabled={true}
                                key={refreshKey}
                                showBorders={true}
                                onContentReady={(e) => {
                                    const hasData = e.component.totalCount() > 0;
                                    e.component.option("pager.visible", hasData);
                                    e.component.option("paging.visible", hasData);
                                }}
                            >
                                <Pager
                                    showPageSizeSelector
                                    allowedPageSizes={[10, 25, 50, 100]}
                                    showNavigationButtons
                                    displayMode="full"
                                    showInfo
                                />
                                <Scrolling
                                    mode="standard"
                                    useNative={true}
                                    scrollByContent={true}
                                    scrollByThumb={true}
                                />
                                <SearchPanel
                                    visible={true}
                                    width={240}
                                    placeholder="Search..."
                                />

                                <Paging defaultPageSize={10} />

                                <Column
                                    dataField="id"
                                    dataType="number"
                                    sortOrder="desc"
                                    visible={false}
                                />

                                <Column
                                    dataField="styleNumber"
                                    caption="Bag no."
                                    width={150}
                                    cellRender={(cell) => (
                                        <span
                                            style={{ cursor: 'pointer', color: 'blue' }}
                                            onClick={() => {
                                                const idHash = encodeValue('1')
                                                navigate(`/inward-from-vendor-process/${idHash}`)
                                            }}
                                        >
                                            {cell.value}
                                        </span>
                                    )}
                                />
                                <Column
                                    dataField="styleNumber"
                                    caption="Style Number"
                                    width={250}
                                    dataType="string"
                                />
                                <Column
                                    dataField="materialType"
                                    width={250}
                                    caption="Material Type"
                                    dataType="string"
                                />
                                <Column
                                    dataField="category"
                                    width={250}
                                    caption="Category"
                                    dataType="string"
                                />
                                <Column
                                    dataField="subCategory"
                                    width={250}
                                    caption="SubCategory"
                                    dataType="string"
                                />
                                <Column
                                    dataField="status"
                                    caption="Status"
                                    cellRender={({ data }) => (
                                        <span>{data.status ? "Accept" : "Reject"}</span>
                                    )}
                                />
                            </DataGrid>
                        )}
                    </Card.Body>
                </Card>
            </div>
        </div>
    )
}

export default InwardFromVendor
